export interface ButtonProps {
  onClick(): void;
}

export function Button(props: React.PropsWithChildren<ButtonProps>) {
  return (
    <button
      className="p-2 text-white transition-colors duration-500 rounded-full shadow-lg bg-main-700 hover:bg-main-500"
      onClick={props.onClick}
    >
      {props.children}
    </button>
  );
}
